export namespace TableSettingsTranslations {
  export const common = {
    tableSettingsUpdatedSuccessfully: 'tableSettingsUpdatedSuccessfully',
  } as const;

  export const productReference = {
    addProductReferenceColumn: 'addProductReferenceColumn',
  } as const;

  export const product = {
    addProductColumn: 'addProductColumn',
  } as const;

  export const asset = {
    addAssetColumn: 'addAssetColumn',
  } as const;

  export const order = {
    addOrderColumn: 'addOrderColumn',
    addProductTransactionColumn: 'addProductTransactionColumn',
  } as const;

  export const container = {
    addContainerColumn: 'addContainerColumn',
  } as const;

  export const lot = {
    addLotColumn: 'addLotColumn',
  } as const;

  export const error = {
    failedToLoadTableSettings: 'failedToLoadTableSettings',
    failedToUpdateAssetTableSettings: 'failedToUpdateAssetTableSettings',
    failedToCreateTableSettings: 'failedToCreateTableSettings',
    unableToFindTableSettings: 'unableToFindTableSettings',
  } as const;
}
